import { MouseEventHandler, useState } from "react";

import classes from "./Button.module.css";
import useTheme from "../hooks/useTheme";

type Props = {
  text: string;
  onClick?: MouseEventHandler;
  isDisabled?: boolean;
  customWidth?: string;
  customMargin?: string;
  customHeight?: string;
  type?: any;
};

const Button = ({
  text,
  onClick,
  isDisabled,
  customWidth,
  customMargin,
  customHeight,
  type,
}: Props) => {
  const [showHover, setShowHover] = useState(false);
  const theme = useTheme();
  const handleMouseEnter = () => {
    setShowHover(true);
  };
  const handleMouseLeave = () => {
    setShowHover(false);
  };
  return (
    <button
      type={type}
      className={classes.btn}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={
        isDisabled
          ? {
              cursor: "initial",
              width: customWidth,
              height: customHeight,
              backgroundColor: theme.colors_ds.NEUTRAL_ICON_WEAK,
              color: theme.colors_ds.NEUTRAL_TEXT_INACTIVE,
            }
          : showHover
          ? {
              backgroundColor: theme.colorTokens.P[90],
              width: customWidth,
              margin: customMargin,
              height: customHeight,
              color: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
            }
          : {
              width: customWidth,
              margin: customMargin,
              height: customHeight,
              backgroundColor: theme.colors_ds.PRIMARY_ICON_MAIN,
              color: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
            }
      }
      onClick={onClick}
      disabled={isDisabled}
    >
      <span>{text}</span>
    </button>
  );
};

export default Button;
